//

import Card from './Card';
import Paper from './Paper';
import Input from './Input';
import Button from './Button';
import Tooltip from './Tooltip';
import Backdrop from './Backdrop';
import Typography from './Typography';
import CssBaseline from './CssBaseline';
import Autocomplete from './Autocomplete';

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme: any) {
  return Object.assign(
    Card(theme),
    Input(theme),
    // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
    Paper(theme),
    Button(theme),
    Tooltip(theme),
    Backdrop(theme),
    Typography(theme),
    // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
    CssBaseline(theme),
    Autocomplete(theme)
  );
}
